import { useMemo } from "react";
import type { Option } from "@/constants/common";
import { useDebounce } from "@/hooks/use-debounce";
import { useGetAllScreenerType } from "@/queries/patient-chart/assessment/assement-forms/use-get-all-screener-type";
import {
  DEF_PAGINATION,
  getXtenantId,
  replaceUnderScoreAddSpace,
} from "@/utils/utils";

export type UseAssessmentOptions = {
  assessmentOptions: Option[];
  onSearchAssessments: (value: string) => void;
};

/** Searchable screener types for the Assessments picker, as select options. */
export const useAssessmentOptions = (): UseAssessmentOptions => {
  const [searchString, onSearchAssessments] = useDebounce<string>("");
  const { data } = useGetAllScreenerType({
    pagination: DEF_PAGINATION,
    xTENANTID: getXtenantId(),
    searchString,
  });

  // The endpoint returns screener names as plain strings despite `OptionData`.
  const assessmentOptions = useMemo<Option[]>(
    () =>
      (data?.data?.content ?? []).map((item) => {
        const name = String(item);
        return { value: name, label: replaceUnderScoreAddSpace(name) };
      }),
    [data]
  );

  return { assessmentOptions, onSearchAssessments };
};
